"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const NumberChange_vue_1 = __importDefault(require("./NumberChange.vue"));
const NumberUnit_vue_1 = __importDefault(require("./NumberUnit.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'NumberArea',
    components: {
        NumberChange: NumberChange_vue_1.default,
        NumberUnit: NumberUnit_vue_1.default
    },
    props: {
        data: {
            type: Number,
            required: true
        },
        color: {
            type: String,
            required: false
        },
        time: {
            type: Number,
            required: false,
            default: 800
        },
        decimal: {
            type: Number,
            required: false,
            default: 0
        },
        comma: {
            type: String,
            required: false,
            default: ','
        },
        format: {
            type: Function,
            required: false,
            default: undefined
        },
        unit: {
            type: String,
            required: true
        },
        unitOption: {
            type: Object,
            required: false,
            default: undefined
        }
    }
});
